function replaceErrorImageByDefaultImage(image, callback) {
    var defaultImage = '';
    var defaultImages = image.dataset.default;

    if (defaultImages !== undefined && defaultImages !== '') {
        defaultImage = defaultImages.split(',');
        defaultImage = defaultImage[defaultImage.length - 1].trim().split(' ')[0];

        var parentNode = image.parentNode;
        if (parentNode.nodeName.toUpperCase() === 'PICTURE') {
            $(image).siblings('source').remove();

            var $picture = $(parentNode);

            var defaultTabletImages = image.dataset.defaultTablet;
            if (defaultTabletImages !== undefined && defaultTabletImages !== '') {
                addDefaultSourceToPicture($picture, '(min-width: 730px)', defaultTabletImages);
            }
            var defaultDesktopImages = image.dataset.defaultDesktop;
            if (defaultDesktopImages !== undefined && defaultDesktopImages !== '') {
                addDefaultSourceToPicture($picture, '(min-width: 1200px)', defaultDesktopImages);
            }
        }

        if (image.src === null || image.src.indexOf(defaultImage) === -1) {
            image.src = defaultImage;
            image.srcset = '';
        }
    }

    if (callback !== undefined) {
        callback(defaultImage);
    }
}

function addDefaultSourceToPicture($picture, media, srcset) {
    var source = document.createElement('source');
    source.srcset = srcset;
    source.media = media;
    $picture.prepend(source);
}